import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'
import styles from './ReturnFiled.sass'

interface Props {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}
export default observer(function ReturnFiledProgressionActions({
  vm,
  canCompleteJob,
}: Props) {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.closeJob()}
          dataTest="job-progression-complete-job-button"
          disabled={!canCompleteJob}
        >
          Close Job
        </Button>
        {!canCompleteJob && (
          <div className={styles.pendingCall}>Pending call completion</div>
        )}
      </CardContent>
    </>
  )
})
